import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PreFooterCallout from '../components/PreFooterCallout';
import { imageUrl } from '../lib/images';

export default function Nyheder() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    async function loadArticles() {
      try {
        const res = await fetch('/_api/public/v2/content/nyheder');
        if (res.ok) {
          const data = await res.json();
          if (data.items && data.items.length > 0) {
            setArticles(data.items);
          }
        }
      } catch {
        // Fallback below
      }
    }
    loadArticles();
  }, []);

  const defaultArticles = [
    {
      slug: 'eksempel-paa-indlaeg-2-2-2',
      title: 'Eksempel på indlæg',
      resume: 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      billede: ['custom-size-6.jpg'],
    },
    {
      slug: 'eksempel-paa-indlaeg-2-2',
      title: 'Eksempel på indlæg',
      resume: 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      billede: ['custom-size-6.jpg'],
    },
    {
      slug: 'eksempel-paa-indlaeg-3',
      title: 'Eksempel på indlæg',
      resume: 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
      billede: ['custom-size-6.jpg'],
    },
  ];

  const displayedArticles = articles.length > 0
    ? articles.map((item) => ({
        slug: item.slug?.da || item.slug || item.id,
        title: item.data?.title || item.title || 'Eksempel på indlæg',
        resume: item.data?.resume || item.resume || 'Lorem ipsum dolor sit amet, ad cum nulla intellegat voluptaria. His mazim docendi tacimates cu, vis ex iisque dissentias, ius ne novum principes.',
        billede: item.data?.billede || item.billede || ['custom-size-6.jpg'],
      }))
    : defaultArticles;

  return (
    <div>
      <SEO
        title="Nyheder - Advokatfirmaet Kopp"
        description="Nyheder og blogindlæg fra Advokatfirmaet Kopp ApS."
      />

      <section className="w-full bg-white py-16 lg:py-24 px-6 lg:px-12 border-b border-slate-200">
        <div className="max-w-[1400px] mx-auto space-y-12">
          <div className="max-w-2xl space-y-4">
            <h1 className="text-3xl lg:text-4xl font-bold text-[#1c3848]">
              Nyheder
            </h1>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {displayedArticles.map((art, idx) => {
              const img = Array.isArray(art.billede) ? art.billede[0] : art.billede;
              return (
                <div key={idx} className="bg-white border border-slate-200 flex flex-col justify-between">
                  <div>
                    <div className="aspect-square w-full overflow-hidden bg-slate-100">
                      <img
                        src={imageUrl(img || 'custom-size-6.jpg', 'width=600,height=600,fit=cover,quality=80,format=auto')}
                        alt={art.title}
                        className="w-full h-full object-cover transition-transform duration-300 hover:scale-102"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-6 space-y-3">
                      <h2 className="text-lg font-bold text-[#1c3848]">
                        {art.title}
                      </h2>
                      <p className="text-xs text-slate-600 leading-relaxed">
                        {art.resume}
                      </p>
                    </div>
                  </div>
                  <div className="px-6 pb-6 pt-2">
                    <Link
                      to={`/${art.slug}/`}
                      className="inline-block px-5 py-2.5 bg-[#1c3848] hover:bg-[#142935] text-white text-[11px] font-semibold lowercase tracking-wider rounded-none transition-colors"
                    >
                      se nyhed
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <PreFooterCallout />
    </div>
  );
}
